<template>
<div>
    <!-- <div class="support-ticket-content-w force-show-folded-info">
        <div class="support-ticket-content">
            <div class="ticket-thread">
                <div class="ticket-reply" v-for="comment in comments" :class="{ 'highlight': userID == comment.id_user_from}">
                    <div class="ticket-reply-info" >
                        <a class="author with-avatar">
                            <img alt="" :src="comment.avatar">
                            <span>{{comment.name}}</span>
                        </a>
                        <span class="info-data">
                            <span class="label">replied on</span>
                            <span class="value">
                                {{comment.created_at}}
                            </span>
                        </span>
                    </div>
                    <div class="ticket-reply-content">
                        {{comment.body}}
                    </div>
                </div>
            </div>
        </div>
        <div class="support-ticket-info">

            <h5 class="info-header">Contributors</h5>
            <div class="info-section">
                <ul class="users-list as-tiles">
                    <li><a class="author with-avatar" href="#">
                            <div class="avatar" style="background-image: url('img/avatar1.jpg')"></div><span>John Mayers</span>
                        </a></li>
                    <li><a class="author with-avatar" href="#">
                            <div class="avatar" style="background-image: url('img/avatar3.jpg')"></div><span>Phil Collins</span>
                        </a></li>
                    <li><a class="author with-avatar" href="#">
                            <div class="avatar" style="background-image: url('img/avatar4.jpg')"></div><span>Carl Lewis</span>
                        </a></li>
                    <li><a class="author with-avatar" href="#">
                            <div class="avatar" style="background-image: url('img/avatar5.jpg')"></div><span>Joshua Kim</span>
                        </a></li>
                </ul>
            </div>
        </div>
    </div> -->
<div class="up-contents">
    <h5 class="element-header">Product Status</h5>
    <div class="row m-b">
        <div class="col-lg-6">
            <div class="row">
                <div class="col-sm-6 b-r b-b">
                    <div class="el-tablo centered padded">
                        <div class="value">4</div>
                        <div class="label">Images Shot</div>
                    </div>
                </div>
                <div class="col-sm-6 b-b b-r">
                    <div class="el-tablo centered padded">
                        <div class="value">12</div>
                        <div class="label">Copy Revisions</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 b-r">
                    <div class="el-tablo centered padded">
                        <div class="value">Live</div>
                        <div class="label">Status</div>
                    </div>
                </div>
                <div class="col-sm-6 b-r">
                    <div class="el-tablo centered padded">
                        <div class="value">12:00:12</div>
                        <div class="label">Total Product Time</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="padded">
                <div class="element-info-with-icon smaller">
                    <div class="element-info-icon">
                        <div class="os-icon os-icon-bar-chart-stats-up"></div>
                    </div>
                    <div class="element-info-text">
                        <h5 class="element-inner-header">Category Trend</h5>
                        <div class="element-inner-desc">Comparison to similar products</div>
                    </div>
                </div>
                <div class="el-chart-w">
                    <div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;">
                        <div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;">
                            <div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div>
                        </div>
                        <div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;">
                            <div style="position:absolute;width:200%;height:200%;left:0; top:0"></div>
                        </div>
                    </div><canvas height="286" id="liteLineChart" width="662" class="chartjs-render-monitor" style="display: block; height: 143px; width: 331px;"></canvas>
                </div>
            </div>
        </div>
    </div>
    <div class="os-tabs-w">
        <div class="os-tabs-controls">
            <ul class="nav nav-tabs bigger">
                <li class="nav-item"><a class="nav-link active show" data-toggle="tab" href="#tab_overview">Activity</a></li>
                <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#tab_sales">Daily Sales</a></li>
            </ul>
            <ul class="nav nav-pills smaller d-none d-md-flex">
                <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#">Today</a></li>
                <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#">7 Days</a></li>
                <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#">14 Days</a></li>
                <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#">Last Month</a></li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane active show" id="tab_overview">
                <div class="timed-activities padded">
                    <div class="timed-activity" v-for="(group,index) in productHistory">
                        <div class="ta-date"><span>{{formatDate(index)}}</span></div>
                        <div class="ta-record-w">
                            <div class="ta-record" v-for="item in group">
                                <div class="ta-timestamp"><strong>{{formatTime(item.created_at)[0]}}</strong> {{formatTime(item.created_at)[1]}}</div>
                                <div class="ta-activity">{{item.description}}</div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div class="tab-pane" id="tab_sales">
                <div class="el-tablo">
                    <div class="label">Unique Visitors</div>
                    <div class="value">12,537</div>
                </div>
                <div class="el-chart-w">
                    <div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;">
                        <div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;">
                            <div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div>
                        </div>
                        <div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;">
                            <div style="position:absolute;width:200%;height:200%;left:0; top:0"></div>
                        </div>
                    </div><canvas height="404" id="lineChart" width="1618" class="chartjs-render-monitor" style="display: block; height: 202px; width: 809px;"></canvas>
                </div>
            </div>
            <div class="tab-pane" id="tab_conversion"></div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import { map, pick } from 'lodash'
export default {
  props: ['comments', 'history'],
  data () {
    return {
      productHistory: ''
    }
  },
  mounted () {
    this.formatProductHistory()
  },
  methods: {
    formatProductHistory () {
      var self = this
      const monthName = item => this.moment(item.created_at, 'YYYY-MM-DD').format('YYYY-MM-DD')
      const sortOrder = item => this.moment(item.created_at)

      self.productHistory = _(self.history)
        .orderBy(sortOrder, 'desc')
        .groupBy(monthName)
        .mapValues(items => map(items, i => pick(i, 'description', 'created_at')))
        .value()
    },
    formatDate (date) {
      return this.moment(date, 'YYYY-MM-DD').format('Do MMM, YYYY')
    },
    formatTime (time) {
      const p1 = this.moment(time).format('hh mm')
      const p2 = this.moment(time).format('a')

      return [p1, p2]
    }
  },
  computed: {
    userID () {
      return this.$store.getters.authUser.id_user
    }
  },
  watch: {
    comments () {},
    history () {
      this.formatProductHistory()
    }
  }
}
</script>
